module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "help"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Documentation"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Documents and articles pertaining to Portal, required software and hot tips (check back often!)'),
      expression: "'Documents and articles pertaining to Portal, required software and hot tips (check back often!)'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), (_vm.rootPage) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('h3', {
    class: _vm.rootPage.slug
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: _vm.rootPage.slug
        }
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.rootPage.title) + "\n                    ")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "pages list-group"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'software-keys'
      }
    }
  }, [_vm._v("Software Keys")])], 1), _vm._v(" "), _vm._l((_vm.rootPage.childPages), function(page) {
    return _c('li', {
      staticClass: "list-group-item",
      class: page.slug
    }, [(page.slug == 'software-installation') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'software-installation'
        }
      }
    }, [_vm._v("\n                            " + _vm._s(page.title) + "\n                        ")]) : _c('router-link', {
      attrs: {
        "to": {
          name: 'help-page',
          params: {
            slug: page.slug
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(page.title) + "\n                        ")]), _vm._v(" "), (_vm.isSoftwarePage && page.childPages) ? _c('ul', {
      staticClass: "list-group"
    }, _vm._l((page.childPages), function(childPage) {
      return _c('li', {
        staticClass: "list-group-item",
        class: childPage.slug
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'help-page',
            params: {
              slug: childPage.slug
            },
            query: {
              software_page: true
            }
          }
        }
      }, [_vm._v("\n                                    " + _vm._s(childPage.title) + "\n                                ")])], 1)
    })) : _vm._e()], 1)
  })], 2)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-948a036a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Help.vue
// module id = 2078
// module chunks = 2